import {useContext} from 'react'
import {useIntl} from 'react-intl'
import {Alert, Checkbox, Flex, Modal, Typography} from 'antd'
import {ExclamationCircleOutlined} from '@ant-design/icons'
import {NavContext} from '../../../../context/global_context'
import {postRequest} from '../../../../services/base'
import {formatDateTime} from '../../../../utils/common'
import Button from '../../../common/Button'

const { Text } = Typography

const SelectTrashFilesModal = ({
  vehicle = null,
  open = false,
  trashFiles = [],
  branchExists = true,
  selectedTrashFiles = [],
  setSelectedTrashFiles = () => {},
  onClose = () => {},
  onDeleted = () => {},
}) => {
  const intl = useIntl()
  const [, navDispatch] = useContext(NavContext)
  const [modal, contextHolder] = Modal.useModal()

  const selectUnSelectFiles = (trash_id) => {
    if (selectedTrashFiles.includes(trash_id)) {
      setSelectedTrashFiles(selectedTrashFiles.filter((id) => id !== trash_id))
    } else {
      setSelectedTrashFiles([...selectedTrashFiles, trash_id])
    }
  }

  const deleteSelectedTrashedFiles = () => {
    modal.confirm({
      title: intl.formatMessage({ id: 'promoteChanges.deleteTrashedFiles' }),
      icon: <ExclamationCircleOutlined />,
      content: intl.formatMessage({ id: 'promoteChanges.deleteTrashConfirm' }),
      centered: true,
      maskClosable: false,
      okText: intl.formatMessage({ id: 'promoteChanges.delete' }),
      okType: 'danger',
      cancelText: intl.formatMessage({ id: 'promoteChanges.cancel' }),
      onOk: async () => {
        navDispatch({
          type: 'loader',
          data: {
            caption: intl.formatMessage({
              id: 'promoteChanges.deletingSelectedFiles',
            }),
            showLoader: true,
          },
          notification: {},
        })

        let payload = {
          trashed_files: selectedTrashFiles,
        }
        let res = await postRequest(
          `/api/delete/promoted-files/trash/delete/${vehicle}/`,
          payload
        )
        if (res?.status) {
          navDispatch({
            type: 'notification',
            data: {
              notification_type: 'success',
              msg: intl.formatMessage({ id: 'promoteChanges.filesDeleted' }),
            },
          })
          onDeleted()
          onClose()
        } else {
          navDispatch({
            type: 'notification',
            data: {
              notification_type: 'error',
              msg: intl.formatMessage({ id: 'promoteChanges.deleteFilesError' }),
            },
          })
          onClose()
        }
      },
    })
  }

  const footer = (
    <Flex align="center" justify="flex-end" gap={12}>
      <Button onClick={onClose}>
        {intl.formatMessage({ id: 'promoteChanges.cancel' })}
      </Button>
      <Button
        type="primary"
        danger
        disabled={!branchExists || selectedTrashFiles?.length === 0}
        onClick={deleteSelectedTrashedFiles}
      >
        {intl.formatMessage({ id: 'promoteChanges.deleteSelectedTrashedFiles' })}
      </Button>
    </Flex>
  )

  return (
    <>
      {contextHolder}
      <Modal
        title={intl.formatMessage({ id: 'promoteChanges.trashFilesTitle' })}
        open={open}
        centered
        maskClosable={false}
        onCancel={() => {
          onClose()
          setSelectedTrashFiles([])
        }}
        footer={footer}
        destroyOnHidden
      >
        {!branchExists && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
            message={intl.formatMessage({
              id: 'promoteChanges.branchMissingTrashDeleteDisabled',
            })}
          />
        )}
        <Flex vertical gap={8} style={{ maxHeight: '50vh', overflowY: 'auto' }}>
          {trashFiles?.length > 0 ? (
            trashFiles.map((trash_file, trashFileIdx) => (
              <div
                key={`trash-file-${trash_file.id || trashFileIdx}`}
                className="promote-trash-file-item"
              >
                <Checkbox
                  disabled={!branchExists}
                  checked={selectedTrashFiles?.includes(trash_file.id)}
                  onChange={() => selectUnSelectFiles(trash_file.id)}
                >
                  <Flex vertical gap={2} style={{ minWidth: 0 }}>
                    <Text ellipsis={{ tooltip: trash_file.name }}>
                      {trash_file.name}
                    </Text>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      {trash_file.model_name} ({formatDateTime(trash_file.created_at)})
                    </Text>
                  </Flex>
                </Checkbox>
              </div>
            ))
          ) : (
            <Flex
              align="center"
              justify="center"
              style={{ padding: '24px' }}
            >
              <Text type="secondary">
                {intl.formatMessage({ id: 'promoteChanges.noRecords' })}
              </Text>
            </Flex>
          )}
        </Flex>
      </Modal>
    </>
  )
}

export default SelectTrashFilesModal
